import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";

type DirectionalExternalArrowProps = {
  className?: string;
};

export default function DirectionalExternalArrow({
  className,
}: DirectionalExternalArrowProps) {
  return (
    <ArrowUpRight
      className={cn("shrink-0 rtl:-scale-x-100", className)}
      aria-hidden
    />
  );
}
